import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReviewFileAvatarModule } from '@portal-core/reviews/review-files/components/review-file-avatar/review-file-avatar.module';
import { ListModule } from '@portal-core/ui/list/list.module';
import { ReviewFileListComponent } from './review-file-list.component';

@NgModule({
  declarations: [ReviewFileListComponent],
  exports: [ReviewFileListComponent],
  imports: [
    CommonModule,
    ListModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatTooltipModule,
    ReviewFileAvatarModule
  ]
})
export class ReviewFileListModule { }
